import PropTypes from 'prop-types';
import { APIProvider } from '@vis.gl/react-google-maps';

import Box from '@mui/material/Box';

import { useResponsive } from 'src/hooks/use-responsive';

import { HEADER } from './config-layout';
import { GOOGLE_MAP_API } from '../../../config-global';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }) {
  const lgUp = useResponsive('up', 'lg');

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        flexDirection: 'column',
        pt: '50px',
        height: '100%',
        width: '100%',
        pb: 0,
        mb: 0,
        ...(lgUp && {
          px: 2,
          pt: `${HEADER.H_DESKTOP + SPACING}px`,
          pb: 0,
          mb: 0,
          height: '100%',
          width: '100%',
        }),
        ...sx,
      }}
      {...other}
    >
      <APIProvider apiKey={GOOGLE_MAP_API}>
        {children}
      </APIProvider>
    </Box>
  );
}

Main.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};
